import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ScrollPanel } from "primeng/scrollpanel";

@Component({
    selector: 'medsurf-design-content-scroll-panel',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './scroll-panel.content.design.html',
    styleUrls: ['./scroll-panel.content.design.scss'],
    standalone: false
})
export class ScrollPanelContentDesign {
  @Input() width = '100%';
  @Input() height = '100%';
  @Input() isMinimized: boolean;
  
  @ViewChild('scrollPanel', {static: false}) scrollPanel: ScrollPanel;
  
  reset() {
    if (this.scrollPanel) {
      this.scrollPanel.scrollTop(0);
    }
  }
  
  scrollTo(scrollTop: number) {
    if (this.scrollPanel) {
      this.scrollPanel.scrollTop(scrollTop);
    }
  }
}
